import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PwaInstallService } from '../../services/pwa-install.service';

@Component({
  selector: 'app-pwa-install-banner',
  templateUrl: './pwa-install-banner.component.html',
  styleUrls: ['./pwa-install-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PwaInstallBannerComponent implements OnInit, OnDestroy {
  showBanner = false;
  isIos = false;
  private subscription!: Subscription;

  constructor(
    private readonly pwaInstallService: PwaInstallService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.isIos = this.pwaInstallService.isIos;
    this.subscription = this.pwaInstallService.showBanner$.subscribe((show) => {
      this.showBanner = show;
      this.cdr.markForCheck();
    });
  }

  install(): void {
    this.pwaInstallService.installApp();
  }

  dismiss(): void {
    this.pwaInstallService.dismissBanner();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
